import { useState, useEffect } from "react";
import { ThemeProvider, CircularProgress, Box } from "@material-ui/core";
import { Route, useLocation, useNavigate } from "react-router-dom";
import { Outlet as Switch } from "react-router-dom";
import Account from "./components/Account";
import Home from "./components/Home";
import { auth } from "./firebase";
import theme from "./theme";
import LinkRedirect from "./components/LinkRedirect";

const App = () => {
  const [user, setUser] = useState(null);
  const { pathname } = useLocation();
  const [initialLoad, setInitialLoad] = useState(
    pathname === "/" || pathname === "/account" ? true : false
  );
  const navigate = useNavigate();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
      setInitialLoad(false);
    });
  }, []);

  useEffect(() => {
    if (initialLoad) return; // Skip navigation during initial load

    if (!user && pathname !== "/") {
      navigate("/"); // Redirect to home if user is not authenticated
    } else if (user && pathname !== "/account") {
      navigate("/account"); // Redirect to account if user is authenticated
    }
  }, [user, initialLoad, pathname, navigate]);

  if (initialLoad)
    return (
      <Box mt={5} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  return (
    <ThemeProvider theme={theme}>
      <Switch>
        <Route exact path="/">
          {user ? <Account /> : <Home />}
        </Route>
        <Route path="/account">{user ? <Account /> : <Home />}</Route>
        <Route path="/:shortCode">
          <LinkRedirect />
        </Route>
      </Switch>
    </ThemeProvider>
  );
};

export default App;